import { useReactiveVar } from '@apollo/client';

import { useLoggingLazyQuery } from 'lib/apollo/apollo-hooks';
import type { ExtendSessionQuery } from './signin-refresh-session.graphql.generated';
import { EXTEND_SESSION } from './signin-refresh-session.graphql';
import { studentAuthApolloContextOption } from 'approot/student-class-to-do/student-class-to-do.utils';
import { isStaleSessionModalOpenVar } from 'lib/session-stale-monitor.apollo';
import { useSnackbar } from 'approot/shared/snackbar-notification/snackbar-notification.hooks';
import { signInStateVar } from 'approot/shared/user/user-data.apollo';
import {
  emitStudentExtendSessionStorageEvent,
  emitTeacherExtendSessionStorageEvent,
} from 'lib/session/session-storage';
import { resetAndExtendSession } from 'lib/session/session-storage-duration';

export const useExtendSession = (props: { token?: string }) => {
  const { isStudentSignedIn } = useReactiveVar(signInStateVar);

  const { showError } = useSnackbar();

  const [extendSession, { loading }] = useLoggingLazyQuery<
    ExtendSessionQuery,
    null
  >(EXTEND_SESSION, {
    fetchPolicy: 'network-only',
    ...(isStudentSignedIn ? { context: studentAuthApolloContextOption() } : {}),
    onCompleted: () => {
      resetAndExtendSession();
      isStaleSessionModalOpenVar(false);

      if (props.token) {
        if (isStudentSignedIn) {
          emitStudentExtendSessionStorageEvent(props.token);
        } else {
          emitTeacherExtendSessionStorageEvent(props.token);
        }
      }
    },
    onError: () => {
      showError(
        'Something went wrong keeping you signed in. Please refresh and try again.'
      );
    },
  });

  return {
    extendSession,
    loading,
  };
};
